import { render, staticRenderFns } from "./search-found.vue?vue&type=template&id=15674900&scoped=true"
import script from "./search-found.vue?vue&type=script&lang=js"
export * from "./search-found.vue?vue&type=script&lang=js"
import style0 from "./search-found.vue?vue&type=style&index=0&id=15674900&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15674900",
  null
  
)

export default component.exports